<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`treatmentProgram.step0.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col class="noYPadding">
        <VAutocomplete
          v-model="data.siteProduct"
          :label="$t('treatmentProgram.step0.productName')"
          :items="displayedProducts"
          :loading="loading"
          :required="true"
          outlined
          data-cy="treatmentProgram_Product_Product"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    name: 'ProgramInfo',
    components: {
        VAutocomplete,
    },
    props: {
        programInfo: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
            products: [],
            treatments: [],
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'component',
            'network',
        ]),
        productsInUsed() {
            return this.treatments.reduce((productsInUsed, product) => ({
                ...productsInUsed,
                [product?.programInfo?.siteProduct?.id]: product?.programInfo?.siteProduct?.id,
            }), {});
        },
        isProductInUsed() {
            return productId => productId in this.productsInUsed;
        },
        displayedProducts() {
            return this.products.map(product => ({
                ...product,
                disabled: this.isProductInUsed(product.id),
            }));
        },
    },
    watch: {
        programInfo: {
            handler() {
                this.data = { ...this.data, ...this.programInfo };
            },
            immediate: true,
        },
    },
    async created() {
        await this.getProducts();
        await this.getTreatments();
    },
    methods: {
        async getProducts() {
            this.loading = true;
            const { data } = await this.$rq.getSiteProducts(this.site.id, { pagination: false });
            this.products = data.products;
            this.loading = false;
        },
        async getTreatments() {
            const queryParams = this.component.id ? { component: this.component.id } : {};
            const { data } = await this.$rq.getTreatmentPrograms(this.network.id, queryParams);
            this.treatments = data;
        },
        updateData() {
            this.$emit('sendData', { programInfo: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.noYPadding {
  padding-bottom: 0px;
  padding-top: 0px;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
